import { logger } from '@/helpers/logger';
import { useQuery } from '@tanstack/react-query';
import { getJson } from '../../helpers/ajax';
import { PRESS_ARTICLE_DATA_PATH } from './consts';
import { PressArticle } from './types';

const getPressArticles = async () => {
  try {
    const data = await getJson<readonly PressArticle[] | undefined>(
      PRESS_ARTICLE_DATA_PATH
    );

    const results = data?.map(
      ({
        id,
        image,
        path,
        mainTag,
        mediaType,
        tags,
        publicationDate,
        teaserText,
        title,
        pressType,
      }) => {
        return {
          id,
          image,
          path,
          mainTag,
          mediaType,
          tags,
          publicationDate,
          teaserText,
          title,
          pressType,
        };
      }
    );

    return results;
  } catch (error) {
    logger.error('getPressArticles', error);
    return [];
  }
};

export default function usePressArticles() {
  return useQuery({
    queryKey: ['press-articles'],
    queryFn: getPressArticles,
  });
}
